// extracted by mini-css-extract-plugin
module.exports = {"labeled-tag-wrapper":"LabeledTag_labeled-tag-wrapper__1Fo0o"};